import {Component, OnDestroy, OnInit} from '@angular/core';
import {PostsService} from '../common/services/posts.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {PostDO} from '../common/data-objects/PostDO';
import {IPageChangeData} from '../common/data-objects/IPageChangeData';
import {Meta, Title} from '@angular/platform-browser';
import {Angulartics2} from 'angulartics2';
import {SeoService} from '../common/services/seo.service';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss']
})
export class SearchPageComponent implements OnInit, OnDestroy {
  posts: PostDO[];
  pagesCount: number;
  itemsCount: number;
  searchText: string;
  isLoading = true;

  private queryParamsSubscription: Subscription;

  constructor(
    private postsService: PostsService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService
  ) {
  }

  ngOnInit(): void {
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      this.searchText = queryParams.get('q');
    });
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  getData({searchText, page}: IPageChangeData) {
    this.isLoading = true;
    this.postsService.getPosts(searchText, page).subscribe(postsData => {
      this.posts = postsData.posts;
      this.pagesCount = postsData.pagesCount;
      this.itemsCount = postsData.itemsCount;
      this.isLoading = false;

      this.titleService.setTitle(this.title);
      this.seoService.setTitle(`${this.title} - Fun Bible`);
      this.seoService.setDescription('Aici vei gasi rezultate dupa cautarea facuta');
      this.meta.updateTag({ property: 'og:url', content: `https://funbible.net/privacy-policy/` });
      const initialKeywords = ['cautare', 'resurse', 'activitati', 'desene animate', 'crestine', 'crestini', 'jocuri', 'jucarii'].join();
      this.meta.updateTag({property: 'keywords', content: initialKeywords});
      this.angulartics2.eventTrack.next({
        action: this.title,
        properties: { category: 'pageView' },
      });
    }, error => {
      this.toastr.error('Nu am putut cauta!');
      this.isLoading = false;
    });
  }

  get title(): string {
    if (this.searchText && this.searchText.trim() !== '') {
      return `Rezultatul căutării „${this.searchText}”`;
    }
    return 'Toate resursele';
  }
}
